import { createActionTypeModel } from "../../../../store/global/action-model";


export const GET_BOOKING_PROMOTERS = 'GET_BOOKING_PROMOTERS';
export const SET_BOOKING_PROMOTERS = 'SET_BOOKING_PROMOTERS';
export const SET_MORE_BOOKING_PROMOTERS = 'SET_MORE_BOOKING_PROMOTERS';
export const DELETE_BOOKING_PROMOTER = 'DELETE_BOOKING_PROMOTER';

export const GET_CLIENT_DISPLAY_NAME = 'GET_CLIENT_DISPLAY_NAME';
export const SET_CLIENT_DISPLAY_NAME = 'SET_CLIENT_DISPLAY_NAME';

export const GET_CONTACTS_FOR_PROMOTER = 'GET_CONTACTS_FOR_PROMOTER';
export const SET_CONTACTS_FOR_PROMOTER = 'SET_CONTACTS_FOR_PROMOTER';
export const SET_MORE_CONTACTS_FOR_PROMOTER = 'SET_MORE_CONTACTS_FOR_PROMOTER';

export const GET_BOOKING_PROMOTER_SELECTED = 'GET_BOOKING_PROMOTER_SELECTED';
export const SET_BOOKING_PROMOTER_SELECTED = 'SET_BOOKING_PROMOTER_SELECTED';

export const SET_BOOKING_PROMOTER_SELECTED_TAB = 'SET_BOOKING_PROMOTER_SELECTED_TAB';

export const GET_BOOKING_PROMOTER_TAB_OVERVIEW = 'GET_BOOKING_PROMOTER_TAB_OVERVIEW';
export const GET_BOOKING_PROMOTER_TAB_BOOKINGS = 'GET_BOOKING_PROMOTER_TAB_BOOKINGS';
export const GET_BOOKING_PROMOTER_TAB_ADDITIONAL_INFO = 'GET_BOOKING_PROMOTER_TAB_ADDITIONAL_INFO';
export const SET_BOOKING_PROMOTER_TAB_OVERVIEW = 'SET_BOOKING_PROMOTER_TAB_OVERVIEW';
export const SET_BOOKING_PROMOTER_TAB_BOOKINGS = 'SET_BOOKING_PROMOTER_TAB_BOOKINGS';
export const SET_BOOKING_PROMOTER_TAB_ADDITIONAL_INFO = 'SET_BOOKING_PROMOTER_TAB_ADDITIONAL_INFO';
export const SET_BOOKING_PROMOTER_TAB_ADDITIONAL_INFO_FILES = 'SET_BOOKING_PROMOTER_TAB_ADDITIONAL_INFO_FILES';
export const UPDATE_BOOKING_PROMOTER_TAB_ADDITIONAL_INFO_FILES = 'UPDATE_BOOKING_PROMOTER_TAB_ADDITIONAL_INFO_FILES';

export const SET_ROUTE_QUERY_MODAL = 'SET_ROUTE_QUERY_MODAL';

export const SET_IS_SELECTED_PROMOTER_LOADING = 'SET_IS_SELECTED_PROMOTER_LOADING';

export const PromoterDetails = createActionTypeModel('PromoterDetails');
export const PromoterContact = createActionTypeModel('PromoterContact');
export const PromoterRelatedContacts = createActionTypeModel('PromoterRelatedContacts');
export const PromoterRelatedFiles = createActionTypeModel('PromoterRelatedFiles');
export const PromoterCustomFields = createActionTypeModel('PromoterCustomFields');